import * as React from "react";
import './modal.css';
import {CSSTransition} from "react-transition-group";
import * as ReactDOM from "react-dom";
import CloseIcon from '@mui/icons-material/Close';

interface ModalProps {
  visible: boolean,
  onCloseRequest: () => any,
  title: string,
  className?: string,
}

export class Modal extends React.Component<ModalProps, {}> {

  private el: HTMLDivElement = null;

  constructor(props: ModalProps) {
    super(props);

    this.el = document.createElement('div');
    this.el.style.display = 'contents';
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(<CSSTransition in={this.props.visible} timeout={1000} classNames="modal">
      <div className={'modal-react'} onClick={(event) => {
        if (event.target === event.currentTarget) {
          event.preventDefault();
         // this.props.onCloseRequest();
        }
      }}>
        <div className={'modal ' + this.props.className}>
          <div className="modal-close" onClick={() => {
            this.props.onCloseRequest();
          }}>
            <div className="right">
              <CloseIcon/>
            </div>
          </div>


          <h3 className="bold">{this.props.title}</h3>
          {this.props.children}
        </div>
      </div>
    </CSSTransition>, this.el);
  }
}

export function ModalFooter(props: { children: React.ReactNode }) {
  return <div className={"modal-footer"}>{props.children}</div>
}